import { XClose } from '@untitled-ui/icons-react';
import { Button as AriaButton } from 'react-aria-components';

import { cx } from '@/lib/utils/cx';

const sizeClasses = {
  xs: 'p-1',
  sm: 'p-1.5',
  md: 'p-2',
} as const;

const iconSizes = {
  xs: 'size-4',
  sm: 'size-5',
  md: 'size-5',
} as const;

export interface CloseButtonProps {
  readonly label?: string;
  readonly size?: keyof typeof sizeClasses;
  readonly onPress?: () => void;
  readonly isDisabled?: boolean;
  readonly className?: string;
}

export function CloseButton({
  label = 'Close',
  size = 'sm',
  onPress,
  isDisabled,
  className,
}: CloseButtonProps) {
  return (
    <AriaButton
      aria-label={label}
      className={cx(
        'rounded-lg text-quaternary transition-colors hover:bg-surface-secondary hover:text-tertiary_hover focus-visible:ring-2 focus-visible:ring-[var(--color-brand-500)] focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-40',
        sizeClasses[size],
        className,
      )}
      isDisabled={isDisabled}
      onPress={onPress}
    >
      <XClose className={iconSizes[size]} strokeWidth={1.5} />
    </AriaButton>
  );
}
